module.exports = __webpack_public_path__ + "static/media/chart-pie.2e405003.svg";